// frontend/src/services/sugestoesApi.js
import axios from 'axios';
const API =
  import.meta.env.VITE_FUNCTIONS_BASE_URL ||
  'https://api-ijsftfgn6a-uc.a.run.app';

export async function sugerirSocios(uid, limit = 6) {
  const { data } = await axios.get(`${API}/sugerirSocios`, {
    params: { uid, limit },
  });
  return data || [];
}
